module.exports = __webpack_public_path__ + "img/pix.c68582d9.png";